module.exports = __webpack_public_path__ + "static/media/logo-DCD-2019.dbc6d82d.png";